import "./PaymentDescription.css"
import MGButton from "../../../components/MGButton/MGButton"
import PaymentDescriptionListItem from "./PaymentDescriptionListItem"
export default function PaymentDescription(
    {
        clickLink,
        primaryButtonClick,
        secondButtonClick
    }
) {
    return (<div className="PaymentDescription-container">
        <section className="PaymentDescription-text-container">
            <span className="PaymentDescription-text-title">Pagamento de Quotas em atraso</span>
            <span className="PaymentDescription-text-description">Por favor regularize as suas quotas para continuar a beneficiar das vantagens de ser Associado.
                O valor será debitado na conta de depósitos à ordem onde habitualmente já são debitadas as suas quotizações.
            </span>
            <span className="PaymentDescription-text-description">
                Se pretende fazer o pagamento de um valor diferente do indicado, queira contactar o seu Gestor Mutualista
            </span>
        </section>
        <section className="PaymentDescription-ticket-container">
            <div className="PaymentDescription-ticket-container-title">
                <span className="PaymentDescription-ticket-title">Quotas em atraso no valor total de:</span>
                <span className="PaymentDescription-ticket-value">52,00 €</span>
            </div>
            <div className="PaymentDescription-ticket-list">
                <PaymentDescriptionListItem
                    title="Inscrição X"
                    date="05/2025"
                    description="Poupança Complementar"
                    value="3,00 €"
                    totalValue="25,00 €" />
                <PaymentDescriptionListItem
                    title="Inscrição X"
                    date="05/2025"
                    description="Poupança Complementar"
                    value="3,00 €"
                    totalValue="25,00 €" />
                <PaymentDescriptionListItem
                    title="Inscrição X"
                    date="05/2025"
                    description="Poupança Complementar"
                    value="3,00 €"
                    totalValue="25,00 €" />
                <PaymentDescriptionListItem
                    title="Inscrição X"
                    date="05/2025"
                    description="Poupança Complementar"
                    value="3,00 €"
                    totalValue="25,00 €" />
            </div>
        </section >
        <section>
            <div className="MGWarning-container-buttons">
                <MGButton label="Pagar Quotas" onClick={primaryButtonClick} type="primary" isEnable={true} />
                <MGButton label="Cancelar" onClick={secondButtonClick} type="secondary" isEnable={true} />
            </div>
            <span class="MGWarning-secondary-text">Se necessitar de apoio ou esclarecimento adicional, </span>
            <span class="MGWarning-secondary-link" onClick={clickLink}>contacte-nos.</span>
        </section >
    </div >);
}